var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-8 text-theme-main leading-loose"},[_c('p',[_vm._v("\n        MIX_AWS_LEGACY_MEDIA: "+_vm._s(_vm.a)),_c('br'),_vm._v("\n        MIX_CLOUDFRONT_DNSNAME: "+_vm._s(_vm.b)),_c('br'),_vm._v("\n        MIX_LEGACY_CLOUDFRONT_DNSNAME: "+_vm._s(_vm.c)),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }